import React, { useState, useEffect } from "react";
import { alpha } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Toolbar from "@mui/material/Toolbar";
import axios from "axios";
import { MoreVert, Error, CheckCircle } from "@mui/icons-material";
import CustomLoading from "../../shared/utils/CustomLoading";
import Styles from "../../styles/vendorDashboard.module.css";
import styles from "../../styles/adminPortal.module.css";
import { useParams } from "react-router-dom";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";

import {
  CircularProgress,
  Tooltip,
  IconButton,
  Pagination,
  FormControl,
  Select,
  MenuItem,
  InputLabel,
  Menu,
  Snackbar,
  Alert,
} from "@mui/material";
import CustomButton from "../utils/Button";
import Decrypt from "../utils/Decrypt";
const columns = [
  {
    field: "businessName",
    headerName: "Business Name",
    width: 180,
  },
  { field: "name", headerName: "Vendor Name", width: 150 },
  { field: "address", headerName: "Address", width: 200 },
  { field: "reliability", headerName: "Reliability", width: 100 },
  { field: "creditLimit", headerName: "Credit Limit", width: 100 },
  { field: "manpower", headerName: "Manpower", width: 100 },
  { field: "productionArea", headerName: "Production Area", width: 140 },

  { field: "contactNumber", headerName: "Contact No", width: 100 },
  { field: "products", headerName: "Products", width: 200 },
  { field: "certificates", headerName: "Certificates", width: 100 },
  // { field: "action", headerName: "Action", width: 80 },
];

const FilteredVendorTable = ({
  vendorList,
  getVendorList,
  filterData,
  availableClusters,
}) => {
  // const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5); // Rows per page
  const [selected, setSelected] = React.useState([]); // State for selected rows
  const [OrganizationListLoading, setOrganizationListLoading] = useState(true);
  const [pageSize, setPageSize] = useState(20);
  const pageSizeOptions = [1, 5, 10, 20, 50, 100];
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRowId, setSelectedId] = useState(null);
  const [open, setOpen] = React.useState(false);
  const maxStars = 5;
  const [searchInputs, setSearchInputs] = useState({
    state: "",
    city: "",
    address: "",
    name: "",
    businessName: "",
  });
  const [allDetails, setAllDetails] = useState(vendorList);

  const handleSearchChangeHead = (e, key) => {
    const value = e.target.value;

    console.log("searching", value, key);
    const searchTerm = value.trim().replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    const searchKeyword = new RegExp(`\\b${searchTerm}\\w*\\b`, "i");

    // Update search inputs state for that particular field
    setSearchInputs((prevState) => ({
      ...prevState,
      [key]: value,
    }));

    // Check if the input is empty and reset the data to vendorList
    if (searchKeyword === "") {
      setAllDetails(vendorList);
    } else {
      console.log("filtering", vendorList);
      // Apply filtering based on the column (key)
      const filterDataBasedOnAddress = vendorList.filter((data) => {
        // For each case, check if the key matches and perform filtering
        switch (key) {
          case "address":
            return searchKeyword.test(data?.address?.toLowerCase());

          case "state":
            return searchKeyword.test(data?.state?.toLowerCase());

          case "city":
            return searchKeyword.test(data?.city?.toLowerCase());

          case "name":
            return searchKeyword.test(Decrypt(data?.ownerName)?.toLowerCase());

          case "businessName":
            return searchKeyword.test(data?.vendorBussinessName?.toLowerCase());

          default:
            return true;
        }
      });

      setAllDetails(filterDataBasedOnAddress); // Update the vendors with the filtered data
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      setOrganizationListLoading(true);
      await getVendorList(page, pageSize);
      setOrganizationListLoading(false);
    };
    fetchData();
  }, [page, pageSize]);

  const handlePageSizeChange = (event) => {
    setPageSize(parseInt(event.target.value));
    setPage(1);
  };
  const handlePageChange = async (e, value) => {
    await getVendorList(value, pageSize);
    setPage(value);
  };
  useEffect(() => {
    setTotalPages(Math.ceil(allDetails?.length / pageSize));
  }, [vendorList, pageSize, allDetails]);

  // Slice the data for the current page
  const currentData = allDetails.slice((page - 1) * pageSize, page * pageSize);

  return (
    <Box>
      {!OrganizationListLoading ? (
        <Paper
          sx={{ overflow: "hidden", boxShadow: "none" }}
          className="px-10 mt-1"
        >
          <EnhancedTableToolbar
            vendorList={vendorList}
            filterData={filterData}
            availableClusters={availableClusters}
          />

          <TableContainer
            sx={{
              height: "calc(75vh - 180px)", // Adjust this to control available space for the table
              maxHeight: "calc(85vh - 150px)", // Ensures the table won't exceed this height
              overflowY: "auto", // Adds scroll when the content exceeds height
            }}
            className={`mt-1 rounded-lg ${Styles["custom-scrollbar"]}`}
          >
            <Table
              stickyHeader
              aria-label="customized table"
              className="rounded-lg "
            >
              <TableHead className={styles.tableHead}>
                <TableRow>
                  {columns.map((column, index) => (
                    <TableCell
                      key={column.field}
                      className={styles.tableCell}
                      sx={{
                        minWidth: column.width,
                      }}
                      // sx={{
                      //   minWidth: column.width,
                      //   backgroundColor: "var(--light-primary-color)",
                      //   fontWeight: "bold",
                      //   height: 90,
                      //   // borderLeft: index === 0 && "1px solid #ccc",
                      //   borderRight:
                      //     index < columns.length - 1
                      //       ? "1px solid #ccc"
                      //       : "none",
                      // }}
                    >
                      <span className={styles.headCellHeading}>
                        {" "}
                        {column.headerName}{" "}
                      </span>
                      <div className={styles.topBorderDiv}>
                        {[
                          "city",
                          "address",
                          "state",
                          "name",
                          "businessName",
                        ].includes(column.field) && (
                          <input
                            type="text"
                            className={styles.searchInput}
                            placeholder={`Search ${column.headerName}`}
                            onChange={(e) =>
                              handleSearchChangeHead(e, column.field)
                            } // Use the handler passed via props
                            value={searchInputs?.[column.field] || ""} // Access search inputs from props
                          />
                        )}
                      </div>
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>
              {currentData && currentData?.length > 0 ? (
                <TableBody>
                  {currentData.map((row, i) => {
                    const isRowSelected = selected.includes(row?.id);
                    return (
                      <TableRow
                        key={i}
                        hover
                        selected={isRowSelected}
                        sx={{
                          borderRight: "1px solid #ccc",
                          cursor: "pointer",
                        }}
                      >
                        <TableCell className={styles.tableRow}>
                          <span>
                            {(() => {
                              const orignalvendorBussinessName =
                                row?.vendorBussinessName || "N/A";

                              const displayEmail =
                                row?.vendorBussinessName?.length > 17
                                  ? row?.vendorBussinessName.substring(0, 17) +
                                    "..."
                                  : row?.vendorBussinessName;

                              return (
                                <Tooltip
                                  title={orignalvendorBussinessName} // Show full email on hover
                                  arrow
                                  placement="top"
                                  disableHoverListener={
                                    row?.vendorBussinessName?.length <= 17
                                  } // Avoid tooltip when full email is shown
                                >
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "inline-block",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {displayEmail}
                                  </span>
                                </Tooltip>
                              );
                            })()}
                          </span>
                        </TableCell>
                        <TableCell className={styles.tableRow}>
                          <span>{Decrypt(row?.ownerName) || "N/A"}</span>
                        </TableCell>
                        {/* <TableCell className={styles.tableRow}>
                          <span>
                            {(() => {
                              const role = localStorage.getItem("role"); // assuming it's stored as a string
                              const isSuperAdmin = role === "-1";

                              const ownerName = row?.ownerName || "N/A";
                              const displayName = ownerName
                                ? Decrypt(ownerName)
                                : ownerName;
                              const short =
                                displayName?.length > 17
                                  ? displayName.slice(0, 17) + "..."
                                  : displayName;

                              return (
                                <Tooltip
                                  title={displayName}
                                  arrow
                                  placement="top"
                                  disableHoverListener={
                                    displayName.length <= 17
                                  }
                                >
                                  <span
                                    style={{
                                      whiteSpace: "nowrap",
                                      overflow: "hidden",
                                      textOverflow: "ellipsis",
                                      display: "inline-block",
                                      maxWidth: "100%",
                                    }}
                                  >
                                    {short}
                                  </span>
                                </Tooltip>
                              );
                            })()}
                          </span>
                        </TableCell> */}
                        <TableCell className={styles?.tableRow}>
                          {(() => {
                            return (
                              <Tooltip
                                title={`${row?.address || ""}, ${
                                  row?.city || ""
                                }, ${row?.state || ""}, ${row?.pincode || ""}`}
                                arrow
                                placement="top"
                                disableHoverListener={
                                  !row?.address ||
                                  row?.address?.length +
                                    row?.city?.length +
                                    row?.state?.length +
                                    row?.pincode?.length <=
                                    20
                                }
                              >
                                <span>
                                  {`${row?.address || ""}, ${
                                    row?.city || ""
                                  }, ${row?.state || ""}, ${row?.pincode || ""}`
                                    .length > 20
                                    ? `${`${row?.address || ""}, ${
                                        row?.city || ""
                                      }, ${row?.state || ""}, ${
                                        row?.pincode || ""
                                      }`.substring(0, 20)}...`
                                    : `${row?.address || ""}, ${
                                        row?.city || ""
                                      }, ${row?.state || ""}, ${
                                        row?.pincode || ""
                                      }`}
                                </span>
                              </Tooltip>
                            );
                          })()}
                        </TableCell>
                        <TableCell className={styles.tableRow}>
                          <span>
                            {Array.from({ length: maxStars }).map(
                              (_, index) => (
                                <span
                                  key={index}
                                  style={{
                                    fontSize: "12px",
                                    marginRight: "2px",
                                  }}
                                >
                                  {index < row?.stars ? "⭐" : ""}
                                </span>
                              )
                            )}
                          </span>
                        </TableCell>
                        <TableCell className={styles.tableRow}>
                          <span>{row?.creditLimit || "N/A"}</span>
                        </TableCell>
                        <TableCell className={styles.tableRow}>
                          <span>{row?.numberOfSkilledManpower || "N/A"}</span>
                        </TableCell>
                        <TableCell className={styles.tableRow}>
                          <Tooltip
                            title={
                              row?.productionArea
                                ? `${row.productionArea} sqft`
                                : "0 sqft"
                            }
                            arrow
                            placement="top"
                            disableHoverListener={
                              !row?.productionArea ||
                              row.productionArea.toString()?.length <= 6
                            } // Avoid tooltip if short
                          >
                            <span>
                              {row?.productionArea &&
                              row.productionArea.toString()?.length > 6
                                ? `${row.productionArea
                                    .toString()
                                    .substring(0, 6)}... sqft`
                                : `${row?.productionArea || "0"} sqft`}
                            </span>
                          </Tooltip>
                        </TableCell>
                        <TableCell className={styles.tableRow}>
                          <span>
                            {Decrypt(row?.ownerPrimaryContactNo) || "N/A"}
                          </span>
                        </TableCell>
                        <TableCell className={styles.tableRow}>
                          {row?.products?.length > 0 ? (
                            <div>
                              {row.products.map((ele, i) => {
                                const fabrication =
                                  ele.typesOfFabrication || [];
                                const printing =
                                  ele.typesOfPrintingProducts || [];

                                const fabricationText = Array.isArray(
                                  fabrication
                                )
                                  ? fabrication.join(", ")
                                  : fabrication;
                                const printingText = Array.isArray(printing)
                                  ? printing.join(", ")
                                  : printing;

                                const shouldShowTooltip =
                                  fabrication.length > 3 || printing.length > 3;

                                return (
                                  <div key={i} className="mb-1">
                                    {fabricationText && (
                                      <Tooltip
                                        title={fabricationText}
                                        disableHoverListener={
                                          !shouldShowTooltip
                                        }
                                      >
                                        <span className="block text-sm truncate max-w-xs">
                                          {fabricationText}
                                        </span>
                                      </Tooltip>
                                    )}
                                    {printingText && (
                                      <Tooltip
                                        title={printingText}
                                        disableHoverListener={
                                          !shouldShowTooltip
                                        }
                                      >
                                        <span className="block text-sm truncate max-w-xs">
                                          {printingText}
                                        </span>
                                      </Tooltip>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          ) : (
                            <div className="py-3">No Products Found</div>
                          )}
                        </TableCell>

                        <TableCell className={styles.tableRow}>
                          <span>
                            {row?.certificates?.length > 0 ? (
                              row?.certificates?.map((ele, i) => {
                                return <span key={i}>{ele.label}</span>;
                              })
                            ) : (
                              <span>N/A</span>
                            )}
                          </span>
                        </TableCell>
                        {/* <TableCell className={styles.tableRow}>
                          <>
                            <Tooltip title="Click">
                              <IconButton
                              // onClick={(e) =>
                              //   handleClick(e, row.organizationDetail._id)
                              // }
                              >
                                <MoreVert
                                  aria-controls="simple-menu"
                                  aria-haspopup="true"
                                  style={{
                                    cursor: "pointer",
                                    color: "var(--primary-color)",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>

                            <Menu
                              id="simple-menu"
                              anchorEl={anchorEl}
                              open={
                                Boolean(anchorEl) &&
                                selectedRowId === row.organizationDetail._id
                              }
                              // onClose={DeleteHandle}
                              PaperProps={{
                                style: {
                                  maxHeight: "100px", // Adjust max height if needed
                                  width: "100px", // Adjust width for smaller menu
                                },
                              }}
                            >
                              {/* <MenuItem
                              onClick={(e) =>
                                handleEditModal(e, row.organizationDetail._id)
                              }
                              disabled={isActionLoading}
                            >
                              <ViewIcon color={"var(--para-color)"} />
                              <p className="ml-2 font-semibold text-[var(--heading-color)]">
                                View
                              </p>
                            </MenuItem>
                            <MenuItem
                              onClick={() =>
                                DeleteHandle(row.organizationDetail._id)
                              }
                            >
                              <Tooltip title="Delete Client">
                                <Trash color="var(--para-color)" />
                              </Tooltip>
                              <p className="ml-2 font-semibold text-[var(--heading-color)]">
                                Delete
                              </p>
                            </MenuItem> */}
                        {/* </Menu>
                          </>
                        </TableCell> */}
                      </TableRow>
                    );
                  })}
                </TableBody>
              ) : (
                <div className="flex justify-center items-center h-64">
                  No Vendors Filtered
                </div>
              )}
            </Table>
          </TableContainer>

          <>
            <hr
              className="mt-1 bg-gray-200 "
              style={{ border: "0.5px solid var(--light-grey-color)" }}
            />
            <div className="flex items-center justify-between mt-1 ">
              <FormControl
                variant="standard"
                size="small"
                sx={{ minWidth: 80 }}
              >
                <InputLabel id="page-size-label">Rows</InputLabel>
                <Select
                  labelId="page-size-label"
                  value={pageSize}
                  onChange={handlePageSizeChange}
                  label="Rows"
                >
                  {pageSizeOptions.map((size, i) => (
                    <MenuItem key={i} value={size}>
                      {size}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <Pagination
                className="p-2 flex justify-center"
                count={totalPages}
                page={page}
                onChange={handlePageChange}
                sx={{
                  "& .MuiPaginationItem-root.Mui-selected": {
                    backgroundColor: "#418cff", // Blue background for selected
                    color: "#fff", // White text for selected
                  },
                  "& .MuiPaginationItem-root.Mui-selected:hover": {
                    backgroundColor: "#3366cc", // Darker blue on hover
                  },
                  "& .MuiPaginationItem-root": {
                    "&:hover": {
                      backgroundColor: "#ddd", // Light gray for hovered items
                    },
                  },
                }}
              />
            </div>
          </>
        </Paper>
      ) : (
        <div className="flex justify-center items-center h-64">
          <CircularProgress />
        </div>
      )}
    </Box>
  );
};
export default FilteredVendorTable;

const EnhancedTableToolbar = ({
  vendorList,
  filterData,
  availableClusters,
}) => {
  const [snackbar, setSnackbar] = React.useState({
    open: false,
    message: "",
    severity: "success",
  });

  const [isPublishing, setIsPublishing] = useState(false);
  const [publishedClusters, setPublishedClusters] = useState([]);

  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const { id } = useParams(); // Get the ID from the URL parameters

  const publishClustersToVendors = async () => {
    // let clusters = await fetchAllClustersBasedOnCampaignId(id);
    if (isPublishing) return;

    setIsPublishing(true);

    try {
      let clusters = filterData?.location;
      if (clusters?.length > 0) {
        const result = [];

        vendorList.forEach((vendor) => {
          clusters.forEach((cluster) => {
            result.push({
              vendorId: vendor.id,
              clusterId: cluster.id,
              campaignId: id,
            });
          });
        });
        // api to publish clusters to vendors
        const responseAfterPublishing = await axios.post(
          `${process.env.REACT_APP_URL}/vendorClusterBatches/publishClustersToVendors`,
          {
            clustersPublishedToVendors: result,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
        if (responseAfterPublishing.data.success) {
          setPublishedClusters((prev) => [
            ...prev,
            ...clusters.map((cluster) => cluster.id),
          ]);

          setSnackbar({
            open: true,
            message: responseAfterPublishing?.data?.message,
            severity: "success",
          });
        } else {
          setSnackbar({
            open: true,
            message:
              responseAfterPublishing?.data?.message || "Something went wrong",
            severity: "error",
          });
        }
      } else {
        setSnackbar({
          open: true,
          message: "Please select a location to proceed",
          severity: "error",
        });
      }
    } catch (error) {
      console.error("Error publishing clusters:", error);
      setSnackbar({
        open: true,
        message: "Failed to publish clusters. Please try again.",
        severity: "error",
      });
    } finally {
      setIsPublishing(false);
    }
  };

  // Check if current clusters are already published
  const currentClusterIds =
    filterData?.location?.map((cluster) => cluster.id) || [];
  const isClustersPublished =
    currentClusterIds.length > 0 &&
    currentClusterIds.every((id) => publishedClusters.includes(id));

  return (
    <>
      <div className="flex justify-between items-center mb-2 shadow-lg p-2 rounded-md">
        <div>{`Total Filtered Vendors : ${vendorList?.length || 0}`}</div>

        <>
          {availableClusters.length > 0 && (
            <div className="ml-2">
              <Tooltip
                title={
                  isClustersPublished
                    ? "Clusters already published"
                    : isPublishing
                    ? "Publishing in progress..."
                    : "Publish Selected Clusters"
                }
              >
                <span
                  className={`inline-block ${
                    isPublishing || isClustersPublished
                      ? "cursor-not-allowed"
                      : "cursor-pointer"
                  }`}
                >
                  <CustomButton
                    className="w-max"
                    text={
                      isClustersPublished
                        ? "Published"
                        : isPublishing
                        ? "Publishing..."
                        : "Publish Selected Clusters"
                    }
                    bgcolor={
                      isClustersPublished || isPublishing
                        ? "var(--disabled-color)"
                        : "var(--primary-color)"
                    }
                    onClick={
                      !isClustersPublished && !isPublishing
                        ? publishClustersToVendors
                        : undefined
                    }
                    disabled={isPublishing || isClustersPublished}
                    isLoading={isPublishing}
                  />
                </span>
              </Tooltip>
            </div>
          )}
        </>

        <Snackbar
          open={snackbar.open}
          autoHideDuration={5000}
          onClose={handleSnackbarClose}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert
            onClose={handleSnackbarClose}
            severity={snackbar.severity}
            icon={
              snackbar.severity === "success" ? (
                <CheckCircle sx={{ color: "white" }} />
              ) : (
                <Error sx={{ color: "white" }} />
              )
            }
            sx={{
              backgroundColor:
                snackbar.severity === "success" ? "green" : "red",
              color: "white",
            }}
          >
            {snackbar.message}
          </Alert>
        </Snackbar>
      </div>
    </>
  );
};
